/* istanbul ignore file */
import { connect } from 'react-redux';
import OutlookConfigView from './OutlookConfigView';
import { getWorkRequestListing, updateWorkRequestData } from '../actions/OutlookConfigActions';

const mapStateToProps = (state, ownProps) => {
    const { outlookConfig } = state;
    
    return {
        outlookConfig,
        store: ownProps.store
    };
}

const mapDispatchToProps = dispact => {
    return {
        getWorkRequestListing: () => {
            dispact(getWorkRequestListing())
        },
        updateWorkRequestData: data => {
            dispact(updateWorkRequestData(data))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OutlookConfigView);